import { render, staticRenderFns } from "./historyMyText.vue?vue&type=template&id=14850427&scoped=true&"
import script from "./historyMyText.vue?vue&type=script&lang=js&"
export * from "./historyMyText.vue?vue&type=script&lang=js&"
import style0 from "./historyMyText.vue?vue&type=style&index=0&id=14850427&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14850427",
  null
  
)

export default component.exports